import React from 'react';

const AssignViewNotLoggedInContext = React.createContext(false);

export default AssignViewNotLoggedInContext;
